//This is the code for the site's resume page.

import {addFooter} from './footer';
import {addMenu} from './sliding-menu';
import {loadResume} from './resume-views'
import {loadHeaderHTML} from './head-html-getter';

//Add the site footer to this page.
addFooter();

//Add the initially-hidden sliding menu to the page.
addMenu();

//Load data from text file.
loadResume();

//Add the HTML to the page header.
loadHeaderHTML();